import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import API from '../../../src/config/axios.config';
import { API_ENDPOINTS } from '../../../src/shared/api-endpoints';

interface ChatFeedbackState {
	chatFeedbackResponse: any;
	status: boolean;
	error: string | null;
}

const initialState: ChatFeedbackState = {
	chatFeedbackResponse: {},
	status: false,
	error: null
};

const chatFeedback = createAsyncThunk<any, any>('chatFeedback/chatFeedback', async (payload, thunkAPI) => {
	try {
		const response = await API.patch(API_ENDPOINTS.CHAT_FEEDBACK, payload);
		return response.data;
	} catch (error: any) {
		return error.response.data;
	}
});

const chatFeedbackSlice = createSlice({
	name: 'chatFeedback',
	initialState,
	reducers: {
		reset: () => initialState
	},
	extraReducers: (builder) => {
		builder
			.addCase(chatFeedback.pending, (state) => {
				state.status = true;
				state.error = null;
			})
			.addCase(chatFeedback.fulfilled, (state, action: PayloadAction<any>) => {
				state.status = false;
				state.chatFeedbackResponse = action.payload;
			})
			.addCase(chatFeedback.rejected, (state, action) => {
				state.status = false;
				state.error = action.error.message || 'Failed to post chat feedback';
			});
	}
});

export { chatFeedback };
export const { reset: resetChatFeedback } = chatFeedbackSlice.actions;
export const chatFeedbackReducer = chatFeedbackSlice.reducer;
